/*
 * Authors: mariushirjanu
 * Created: 31/08/2022
 */
import { Input, Component } from '@angular/core';
import { IUserWebshop } from '../../../shared/services/auth/auth-data.service';
import { FormattingService } from '../../../shared/services/formatting.service';

@Component({
  selector: 'spend-limit-info',
  template: `
    <div *ngIf="userWebshops?.length === 1">
      <p class="spend-limit-info" translate [translateParams]="{
        totalSpendLimit: formatAmount(userWebshops[0].totalSpendLimit, userWebshops[0].spendLimitCurrency), 
        remaining: formatAmount(userWebshops[0].remainingSpendLimit, userWebshops[0].spendLimitCurrency)
        }">
        APP.USER_PROFILE.SPEND_LIMIT_INFO
      </p>
    </div>
    
    <div *ngIf="userWebshops?.length > 1">
      <div class="spend-limit-info" *ngFor="let webshop of userWebshops; trackById">
        <strong>{{webshop.webshopName}}</strong>
        <p translate [translateParams]="{
          totalSpendLimit: formatAmount(webshop.totalSpendLimit, webshop.spendLimitCurrency),
          remaining: formatAmount(webshop.remainingSpendLimit, webshop.spendLimitCurrency)
          }">
          APP.USER_PROFILE.MULTI_SPEND_LIMIT_INFO
        </p>
      </div>
    </div>
  `
})
export class SpendLimitInfoComponent {
  @Input() public userWebshops:IUserWebshop[];

  public formatAmount:Function = this.formattingService.formatAmount;

  constructor(
    private formattingService:FormattingService
  ) {
    /***/
  }
}